/**
 * Created by Victor Rojo on 10/5/19.
 */
import { Component }     from '@angular/core';

@Component({
  templateUrl: './Charts.component.html',
  styleUrls: ['./Charts.component.css']
})
export class ChartsComponent {

}
